module.exports = __webpack_public_path__ + "img/news38-0.80136afb.png";